<!-- 销售明细查询 查询 报表 -->
<template>
    <dataQueryTemplate ref="dataQueryTemplate"></dataQueryTemplate>
  </template>
  <script>
  export default {
    methods: {
      toDetail(orderId) {
        if (orderId) {
          // 设置为true 打开穿透组件首页
          var isPenetrate = true;
          // 设置缓存 存入点击单号
          this.resetSetItem("penetrateOrderId", orderId);
          // 与父级跨域通信 传递isPenetrate参数
          window.parent.postMessage(
            {
              //向窗口发送MessageEvent消息
              cmd: "returnFormJson",
              params: { isPenetrate }, //参数
            },
            "*"
          );
        }
      },
    },
  };
  </script>
  